// Parent route for /night/$id/* — pass-through, children handle UI.
import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/night/$id')({
  component: () => <Outlet />,
})
